/**
 * Resolve user-facing name + tagline + description for an App based on
 * the active UI locale. Same shape and fallback rules as localizedPost:
 * per-locale overrides live in `translations`, with the canonical
 * name/description as the final fallback.
 *
 * `tagline` is the one-line card subtitle (catalogue grid, mega-menu).
 * When the admin hasn't filled it explicitly, we fall back to the first
 * paragraph of the long description so cards never look empty when a
 * description is set.
 */
function firstParagraph(text, max = 140) {
  if (!text) return '';
  const trimmed = text.trim();
  const para = trimmed.split(/\n\s*\n/)[0] || trimmed;
  const oneLine = para.replace(/\s+/g, ' ').trim();
  if (oneLine.length <= max) return oneLine;
  // Cut at the last word boundary before max so we don't slice mid-word.
  const cut = oneLine.slice(0, max);
  const lastSpace = cut.lastIndexOf(' ');
  return (lastSpace > 60 ? cut.slice(0, lastSpace) : cut).trim() + '…';
}

export function localizedApp(app, locale) {
  if (!app) return { name: '', tagline: '', description: '' };
  const tr = app.translations || {};
  const wanted = tr[locale] || {};
  const fallback = tr.fr || {};
  const name        = (wanted.name?.trim()        || app.name        || '').trim();
  const description = (wanted.description?.trim() || app.description || '').trim();
  const tagline     = (wanted.tagline?.trim()
                     || fallback.tagline?.trim()
                     || firstParagraph(description));
  return { name, tagline, description };
}
